module.exports = __webpack_public_path__ + "static/media/firefox-developer-edition_256x256.7934f355.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/browser-logos/src/firefox-developer-edition/firefox-developer-edition_256x256.png
// module id = 2882
// module chunks = 0